<template>
  <div class="task-selector mb-3">
    <label class="form-label small text-muted mb-1">Scope the chat to a task (optional)</label>
    <select
      class="form-select"
      :value="selectedSubtaskId == null ? '' : String(selectedSubtaskId)"
      @change="onChange($event.target.value)"
    >
      <option value="">General (no task)</option>
      <optgroup v-for="grp in groupedOptions" :key="grp.title" :label="grp.title">
        <option v-for="opt in grp.items" :key="opt.value" :value="String(opt.value)">
          {{ opt.title }}
        </option>
      </optgroup>
    </select>
  </div>
</template>

<script>
export default {
  name: 'TaskSelector',
  props: {
    // [{ title, items: [{ title, value }] }]
    groupedOptions: { type: Array, default: () => [] },
    selectedSubtaskId: { type: [String, Number], default: null },
  },
  emits: ['update:selectedSubtaskId'],
  methods: {
    onChange(value) {
      this.$emit('update:selectedSubtaskId', value === '' ? null : String(value));
    },
  },
};
</script>
